import { AccessControl, withErrorBoundary } from '@nile/components';
import {
  CellWrapper,
  DisabledTag
} from '@nile/mangifera/src/Pebbles/TicketContainer';
import { Link } from '@superops/ui-design-system';
import React from 'react';
import styled from 'styled-components';

const SubjectCellWrapper = styled.div`
  max-width: 100%;
  .Polaris-Link {
    height: 100%;
  }
  .Polaris-Link {
    width: 100%;
  }
  .subject {
    height: auto !important;
  }
`;

function ScheduleNameCell(props) {
  const { cell, column } = props;
  const value = column.subAccessor
    ? cell.value[column.subAccessor]
    : cell.value;
  /* revisit dangerouslySetInnerHTML xss  */
  return value ? (
    <SubjectCellWrapper>
      <CellWrapper className="ellipsis" id={value}>
        <AccessControl
          roleToCheck="ticketScheduler.edit"
          render={
            <Link
              removeUnderline
              url={`#/onboard/ticketscheduler/${cell.row.original.scheduleId}/edit`}
            >
              {value}
            </Link>
          }
          fallback={value}
        />
      </CellWrapper>
    </SubjectCellWrapper>
  ) : (
    <DisabledTag>NA</DisabledTag>
  );
}

export default ScheduleNameCell;
